import * as React from 'react';
import { SectionContent } from '@components/Sections/Sections.s';
import { HeadingCenter, SmallCardHeading, SmallCardParagraph } from '@components/Typos/Typos.s';
import { Card } from '@components/Card/Card.s';
import { Wrapper, CardsWrapper, CardIconWrapper } from './SectionCards.s';
import { Eye, Social, Ticket } from '@components/Icons';

export const SectionCards = () => (
  <Wrapper>
    <SectionContent>
      <HeadingCenter>Start en quelques mots</HeadingCenter>
      <CardsWrapper>
        <Card>
          <CardIconWrapper><Eye /></CardIconWrapper>
          <SmallCardHeading>Plus d’excuse pour louper des expositions</SmallCardHeading>
          <SmallCardParagraph>
            Une expo t’a tapé dans l’oeil ? Ne loupe plus jamais une expo qui te plaît,
            on s’occupe de te rappeller dès qu’elle arrive à son terme.
          </SmallCardParagraph>
        </Card>
        <Card>
          <CardIconWrapper><Ticket /></CardIconWrapper>
          <SmallCardHeading>Centralise tous tes billets et n’oublie aucune réservation</SmallCardHeading>
          <SmallCardParagraph>
            Réserve ton billet directement dans l’app, on s’occupe de l’ajouter
            à ton calendrier et de te le rappeler le jour J.
          </SmallCardParagraph>
        </Card>
        <Card>
          <CardIconWrapper><Social /></CardIconWrapper>
          <SmallCardHeading>Garde une trace de ton exploration culturelle</SmallCardHeading>
          <SmallCardParagraph>
            Retrouve l’historique de toutes tes visites avec les détails des expositions
            et connecte toi avec tes amis. 
          </SmallCardParagraph>
        </Card>
      </CardsWrapper>
    </SectionContent>
  </Wrapper>
);


// WEBPACK FOOTER //
// src/app/src/components/SectionCards/SectionCards.tsx